module.exports = __webpack_public_path__ + "img/img_agent_cooperate_us@3x.83423964.png";